export default "__VITE_ASSET__DolDNjD$__"